<!-- Removed the sidebar margin and moved the button to the top of the component -->
<button class="sidebar__button" [ngClass]="{ sidebar__button_collapsed: isSidebarCollapsed }" (click)="toggleSidebar()" tabindex="0">
    <div class="sidebar__button-icon">
        <span></span>
        <span>
            <span></span>
            <span></span>
        </span>
        <span></span>
    </div>

    <div class="visually-hidden">Open sidebar</div>
</button>

<!-- Main sidebar -->
<!-- Use nav for navigation sidebar (Valid HTML5 semantics) -->
<nav *ngIf="isSidebarExpanded" aria-label="Sidebar">
    <p-panel class="sidebar sidebar_expanded sidebar_large" [ngClass]="{ sidebar_collapsed: isSidebarCollapsed }">
        <!-- Skeleton is visible while sidebar content is loading -->
        <div *ngIf="showSkeleton" class="skeleton sidebar__skeleton">
            <div class="visually-hidden">Sidebar is loading...</div>
            <div *ngFor="let item of skeletonMenu; let index = index" class="skeleton__item skeleton__item-background" aria-hidden="true"></div>
        </div>

        <clr-vertical-nav class="sidebar__menu menu menu_expanded" [clrVerticalNavCollapsible]="false" [attr.aria-busy]="showSkeleton">
            <ng-container *ngFor="let item of mainSidebarList">
                <a
                    *ngIf="!item.mb_password_type"
                    class="menu__link"
                    clrVerticalNavLink
                    [ngClass]="{ menu__link_disabled: !item.mb_is_enabled_role }"
                    [routerLink]="item.mb_router_link"
                    routerLinkActive="active"
                    (click)="collapseSidebar()"
                >
                    <img class="menu__icon" clrVerticalNavIcon src="/assets/img/sidebar/{{ item.icon }}" alt="" aria-hidden="true" />
                    {{ item.mb_name }}
                </a>

                <!-- Use a button instead of a link (Proper way to make buttons that does not route to another url) -->
                <button
                    *ngIf="item.mb_password_type"
                    class="menu__link"
                    clrVerticalNavLink
                    [ngClass]="{ menu__link_disabled: !item.mb_is_enabled_role }"
                    (click)="openPopup(item.password, item.mb_router_link, $event)"
                >
                    <img class="menu__icon" clrVerticalNavIcon src="/assets/img/sidebar/{{ item.icon }}" alt="" aria-hidden="true" />
                    {{ item.mb_name }}
                </button>
            </ng-container>

            <!-- Divider will be displayed when the data has loaded -->
            <div *ngIf="!showSkeleton" class="sidebar__divider">
                <div class="visually-hidden">Optimus Plus Section</div>
                <img class="divider__image" src="/assets/img/sidebar/Plus.svg" width="45px" height="25px" />
            </div>

            <a
                *ngFor="let item of extraSidebarList"
                class="menu__link extra-link"
                clrVerticalNavLink
                [ngClass]="{ menu__link_disabled: !item.mb_is_enabled_role }"
                [tabindex]="isTabbable(!item.mb_is_enabled_role)"
            >
                <img class="menu__icon" clrVerticalNavIcon src="/assets/img/sidebar/{{ item.icon }}" alt="" aria-hidden="true" />
                {{ item.mb_name }}
            </a>
        </clr-vertical-nav>
    </p-panel>
</nav>

<!-- Sidebar for mainSidebarList -->
<!-- Use nav for navigation sidebar (Valid HTML5 semantics) -->
<nav
    *ngIf="!isSidebarExpanded"
    class="sidebar sidebar_unexpanded sidebar_large"
    [ngClass]="{ sidebar_collapsed: isSidebarCollapsed }"
    [attr.aria-hidden]="isSidebarCollapsed"
    aria-label="Sidebar"
>
    <!-- Skeleton is visible while sidebar content is loading -->
    <div *ngIf="showSkeleton" class="skeleton sidebar__skeleton">
        <div class="visually-hidden">Sidebar is loading...</div>
        <div *ngFor="let item of skeletonMenu; let index = index" class="skeleton__item skeleton__item-background" aria-hidden="true"></div>
    </div>

    <ul class="sidebar__menu menu menu_unexpanded" [attr.aria-busy]="showSkeleton">
        <li *ngFor="let item of mainSidebarList" class="menu__item" [ngClass]="{ menu__item_disabled: !item.mb_is_enabled_role }">
            <a
                *ngIf="!item.mb_password_type"
                class="menu__link"
                [routerLink]="item.mb_router_link"
                (click)="collapseSidebar()"
                [tabindex]="isTabbable(isSidebarCollapsed)"
            >
                <img class="menu__icon" src="/assets/img/sidebar/{{ item.icon }}" alt="" aria-hidden="true" />
                <span class="menu__label">{{ item.mb_name }}</span>
            </a>

            <!-- Use a button instead of a link (Proper way to make buttons that does not route to another url) -->
            <button
                *ngIf="item.mb_password_type"
                class="menu__link"
                (click)="openPopup(item.password, item.mb_router_link, $event)"
                [tabindex]="isTabbable(isSidebarCollapsed)"
            >
                <img class="menu__icon" src="/assets/img/sidebar/{{ item.icon }}" alt="" aria-hidden="true" />
                <span class="menu__label">{{ item.mb_name }}</span>
            </button>
        </li>
    </ul>
</nav>

<!-- Sidebar for width less than 992px -->
<div class="sidebar-wrapper_small">
    <button class="sidebar__button_small" (click)="toggleSidebar()">
        <img src="/assets/img/menu-hamburger.svg" />
    </button>

    <div class="sidebar__background" [ngClass]="{ sidebar__background_collapsed: isSidebarCollapsed }" (click)="collapseSidebar()"></div>

    <!-- Use nav for navigation sidebar (Valid HTML5 semantics) -->
    <nav class="sidebar sidebar_small" [ngClass]="{ sidebar_collapsed: isSidebarCollapsed }">
        <div class="sidebar__close-button" (click)="collapseSidebar()"></div>

        <div class="sidebar__content">
            <h3 class="sidebar__title">{{ businessName }}</h3>
            <app-topbar></app-topbar>

            <!-- Skeleton is visible while sidebar content is loading -->
            <div
                *ngIf="showSkeleton"
                class="skeleton sidebar__skeleton"
                [ngClass]="{ skeleton_expanded: isSidebarExpanded, skeleton_unexpanded: !isSidebarExpanded }"
            >
                <div class="visually-hidden">Sidebar is loading...</div>
                <div *ngFor="let item of skeletonMenu; let index = index" class="skeleton__item skeleton__item-background" aria-hidden="true"></div>
            </div>

            <div
                class="sidebar__menu menu"
                [ngClass]="{ menu_expanded: isSidebarExpanded, menu_unexpanded: !isSidebarExpanded }"
                [attr.aria-busy]="showSkeleton"
            >
                <!-- Expanded sidebar -->
                <!-- Removed the scrollbar panel (No reason to use it) -->
                <div *ngIf="isSidebarExpanded">
                    <div class="menu__section">
                        <ng-container *ngFor="let item of mainSidebarList">
                            <a
                                *ngIf="!item.mb_password_type"
                                class="menu__link"
                                [ngClass]="{ menu__link_disabled: !item.mb_is_enabled_role }"
                                [routerLink]="item.mb_router_link"
                                (click)="collapseSidebar()"
                            >
                                <img class="menu__icon" src="/assets/img/sidebar/{{ item.icon }}" />
                                <span class="menu__label">{{ item.mb_name }}</span>
                            </a>
                            <button
                                *ngIf="item.mb_password_type"
                                class="menu__link"
                                [ngClass]="{ menu__link_disabled: !item.mb_is_enabled_role }"
                                (click)="openPopup(item.password, item.mb_router_link, $event)"
                            >
                                <img class="menu__icon" src="/assets/img/sidebar/{{ item.icon }}" />
                                <span class="menu__label">{{ item.mb_name }}</span>
                            </button>
                        </ng-container>
                    </div>

                    <div *ngIf="!showSkeleton" class="sidebar__divider">
                        <img class="divider__image" src="/assets/img/Plusmobile.png" />
                    </div>

                    <div class="menu__section">
                        <a
                            *ngFor="let item of extraSidebarList"
                            class="menu__link extra-link"
                            [ngClass]="{ menu__link_disabled: !item.mb_is_enabled_role }"
                        >
                            <img class="menu__icon" src="/assets/img/{{ item.icon }}" />
                            <span class="menu__label">{{ item.mb_name }}</span>
                        </a>
                    </div>
                </div>

                <!-- Unexpanded sidebar -->
                <!-- Removed the scrollbar panel (No reason to use it) -->
                <div *ngIf="!isSidebarExpanded">
                    <ng-container *ngFor="let item of mainSidebarList">
                        <a
                            *ngIf="!item.mb_password_type"
                            class="menu__link"
                            [ngClass]="{ menu__link_disabled: !item.mb_is_enabled_role }"
                            [routerLink]="item.mb_router_link"
                            (click)="collapseSidebar()"
                        >
                            <img class="menu__icon" src="/assets/img/sidebar/{{ item.icon }}" />
                            <span class="menu__label">{{ item.mb_name }}</span>
                        </a>
                        <button
                            *ngIf="item.mb_password_type"
                            class="menu__link"
                            [ngClass]="{ menu__link_disabled: !item.mb_is_enabled_role }"
                            (click)="openPopup(item.password, item.mb_router_link, $event)"
                        >
                            <img class="menu__icon" src="/assets/img/sidebar/{{ item.icon }}" />
                            <span class="menu__label">{{ item.mb_name }}</span>
                        </button>
                    </ng-container>
                </div>
            </div>
        </div>

        <div class="sidebar__footer">
            <img class="footer__image" src="/assets/img/Optimus-tagline-logo.svg" />
            <a class="footer__link" href="#">שתף עם חבר <img class="footer__link-image" src="/assets/img/share.svg" /></a>
        </div>
    </nav>
</div>

<p-overlayPanel class="overlay-panel" #overlayPanel (onHide)="onHideOverlay()" [showCloseIcon]="true" [dismissable]="true">
    <h4 class="overlay-panel__title">נא להקליד ססימה</h4>
    <input class="overlay-panel__input" #passwordInput1 type="password" [(ngModel)]="enteredPassword" (keyup.enter)="submitPassword()" />
    <button class="overlay-panel__button button button_theme_main" (click)="submitPassword()">זיהוי סיסמה</button>
</p-overlayPanel>

<div *ngIf="scrWidth < 991" class="dialog-background" [ngClass]="{ 'dialog-visible-background': dialogVisible }" (click)="onHideDialog()"></div>

<p-dialog *ngIf="scrWidth < 991" class="dialog-panel" (onHide)="onHideDialog()" [(visible)]="dialogVisible">
    <h4 class="overlay-panel__title">נא להקליד ססימה</h4>
    <input class="overlay-panel__input" #passwordInput2 type="password" [(ngModel)]="enteredPassword" (keyup.enter)="submitPassword()" />
    <button class="overlay-panel__button button button_size_small button_theme_main" (click)="submitPassword()">זיהוי סיסמה</button>
</p-dialog>

<p-messages class="messages"></p-messages>
